export const HOME = '/';
export const LOGIN = '/auth/login';
export const PROFILE_VIEW = '/page/view';
export const MY_SIGNATURES = '/signatures/me';
export const PROFILE_EDIT = '/profile/edit';
export const CHANGE_PASS = '/profile/changePass';
export const USER_SEARCH = '/users/search';
export const USER_CHECKPOINTS = '/users/checkpoints';
export const USER_BUILDERS = '/users/builders';
export const SW_LIST = '/sw/list';
export const SW_EDIT = '/sw/edit/:id';
export const SW_ADD = '/sw/add';
export const SW_MIGRATE = '/sw/migrate';
export const PROVIDER_LIST = '/provider/list';
export const PROVIDER_EDIT = '/provider/edit/:id';
export const PROVIDER_ADD = '/provider/add';
export const PRE_REGISTER_NGO_LIST = '/ngo//preregister/list';
export const NGO_LIST = '/ngo/list';
export const NGO_EDIT = '/ngo/edit/:id';
export const NGO_ARRIVALS = '/ngo/arrivals';
export const NGO_ADD = '/ngo/add';
export const CHILDREN_LIST = '/children/list';
export const CHILDREN_EDIT = '/children/edit/:childId';
export const CHILDREN_ADD = '/children/add';
export const CHILDREN_PRE_REGISTER = '/children/preregister';
export const CHILDREN_PRE_REGISTER_LIST = '/children/preregister/list';
export const NEED_LIST = '/need/list';
export const NEED_CONFIRM = '/need/confirm';
export const NEED_EDIT = '/need/edit/:childId/:needId';
export const NEED_ADD = '/need/add';
export const REPORTS = '/report/needs/paid';
export const DAO_HOME = '/dao';
export const NEED_MIDJOURNEY = '/midjourney/list';
export const NEED_COMMENT = '/comment/list';
export const CONTRIBUTION = '/contribution/list';
export const CAMPAIGN_MONTHLY = '/campaign/list';
export const CAMPAIGN_NEWSLETTER = '/newsletter/add';
export const UI_PERMISSIONS = '/permissions'; // only UI level for onboarding new admins
